
function subscribe(eventType, listener)
{
	document.addEventListener(eventType, listener)
}

function unsubscribe(eventType, listener)
{
	document.removeEventListener(eventType, listener)
}

function once(eventType, listener)
{
	subscribe(eventType, handleEventOnce)

	function handleEventOnce(event)
	{
		listener(event)
		unsubscribe(eventType, handleEventOnce)
	}
}

function trigger(eventType, data)
{
	const event = new CustomEvent(eventType, { bubbles: false, cancelable: true, detail: data })
	document.dispatchEvent(event)
}

export { subscribe, unsubscribe, once, trigger }
